<wo-download-template-skeleton
  [label]="'Download template file'"
  [btnLabel]="'Download template'"
  [loading]="loading"
  (download)="download()"
>
  <ng-content/>
</wo-download-template-skeleton>
